<template>
  <div class="main main--setting">
    <div class="main__title main__title--3row">
      <div class="sort">
      </div>
      <h2>店鋪設定</h2>
      <div>
        <span v-if="isNotEditing" @click="toEdit">修改設定</span>
        <span v-else @click="toEdit">完成</span>
      </div>
    </div>
    <div class="main__setting">
      <div class="item">
        <div class="item__title">
          名稱
        </div>
        <div class="item__content">
          <span v-if="isNotEditing">{{ shopDeatails.shopName }}</span>
          <input v-else type="text" v-model="shopDeatails.shopName" />
        </div>
      </div>
      <div class="item">
        <div class="item__title">
          介紹
        </div>
        <div class="item__content">
          <span v-if="isNotEditing">{{ shopDeatails.shopFullDescription }}</span>
          <input v-else type="text" v-model="shopDeatails.shopFullDescription" />
        </div>
      </div>
      <div class="item">
        <div class="item__title">
          電話
        </div>
        <div class="item__content">
          <span v-if="isNotEditing">{{ shopDeatails.shopPhoneNumber }}</span>
          <input v-else type="text" v-model="shopDeatails.shopPhoneNumber" />
        </div>
      </div>
      <div class="item">
        <div class="item__title">
          地址
        </div>
        <div class="item__content">
          <span v-if="isNotEditing">{{ shopDeatails.shopAddressRegion }}</span>
          <input v-else type="text" v-model="shopDeatails.shopAddressRegion" />

          <span v-if="isNotEditing">{{ shopDeatails.shopAddressDistrict }}</span>
          <input v-else type="text" v-model="shopDeatails.shopAddressDistrict" />

          <span v-if="isNotEditing">{{ shopDeatails.shopAddressFull }}</span>
          <input v-else type="text" v-model="shopDeatails.shopAddressFull" />
        </div>
      </div>
      <div class="item">
        <div class="item__title">
          開放時間
        </div>
        <div class="item__content">
          <ul>
            <li
              v-for="(item, index) in shopDeatails.shopOpenPeriod"
              :key="index"
            >
              <span v-if="item.isOpen">
                星期{{ index }}：
                <span v-if="isNotEditing">開放</span>
                <span v-if="isNotEditing">{{ item.openAt }}</span>
                <input v-else type="text" v-model="item.openAt" />
                -
                <span v-if="isNotEditing">{{ item.closeAt }}</span>
                <input v-else type="text" v-model="item.closeAt" />
              </span>
            </li>
          </ul>
        </div>
      </div>
      <div class="item">
        <div class="item__title">
          提供的服務
        </div>
        <div class="item__content">
          <ul>
            <li
              v-for="(service, index) in shopDeatails.servicesType"
              :key="index"
            >
              <span v-if="isNotEditing">{{ service.service }}</span>
              <input v-else type="text" v-model="service.service" />
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const fb = require('@/firebaseConfig.js')

export default {
  data () {
    return {
      isNotEditing: true,
      shopDeatails: [],
      shop: {
        shopId: '',
        shopName: '龍威大車房',
        shopFullDescription: '我地係一間信譽良好 ge 車房。',
        shopPhoneNumber: 93682534,
        shopWebLink: '',
        shopRegion: '新界',
        shopDistrict: '元朗',
        shopRoad: '大馬路 178 號',
        shopGeopoint: '',
        staffList: {
          staffId: {
            staffName: 'Jimmy Chu',
            staffRole: 'Boss'
          } },
        shopOpenPeriod: {
          0: { // Sunday
            isOpen: true,
            openAt: '9:00',
            closeAt: '17:00'
          },
          1: {
            isOpen: true,
            openAt: '9:00',
            closeAt: '17:00'
          },
          2: {
            isOpen: true,
            openAt: '9:00',
            closeAt: '17:00'
          },
          3: {
            isOpen: true,
            openAt: '9:00',
            closeAt: '17:00'
          },
          4: {
            isOpen: true,
            openAt: '9:00',
            closeAt: '17:00'
          },
          5: {
            isOpen: true,
            openAt: '9:00',
            closeAt: '17:00'
          },
          6: {
            isOpen: true,
            openAt: '9:00',
            closeAt: '17:00'
          }
        },
        servicesType: {
          0: {
            service: '汽車美容'
          },
          1: {
            service: '鍍膜'
          }
        }
      }
    }
  },
  mounted () {
    fb.shopCollection.doc(this.$store.state.CurrectStaffProfile.shopId).get().then(res => {
      this.shopDeatails = res.data()
    }).catch(err => {
      console.log(err)
    })
  },
  methods: {
    toEdit: function () {
      if (this.isNotEditing === true) {
        this.isNotEditing = false
      } else {
        this.isNotEditing = true
      }
    },
    toFinishEdit: function () {

    }
  }
}
</script>

<style lang="scss" scoped>
.main__setting {
  .item {
    display: flex;
    border-bottom: 1px solid var(--color-grey-lighter);
    padding: calc(var(--box-padding-size)) var(--box-padding-size);

    .item__title {
      font-weight: 700;
      margin-right: 1rem;
    }

    input {
    }

    &:first-child {
      border-top: 1px solid var(--color-grey-lighter);
    }
  }
}
</style>
